
<mat-card class="filter settingHeader">
  <div class="name">
    Manage Shared Roles
  </div>
  <div class="quickAction">   
  </div>
</mat-card>

<mat-card class="documents" *ngIf="CoreName!=''">
  <div class="topBar">
    <span>{{CoreName}}</span>
    <div class="assignSave">     
      <button *ngIf="SaveCoreButton" mat-stroked-button color="primary"
         (click)="SaveCoreRole()">Save</button>
    </div>
  </div>
  <div class="roleList">    
      <div class="multiDrop">
        <ng-multiselect-dropdown
        [placeholder]="'Search or Select'"
        [settings]="CoredropdownSettings"
        [data]="CoredropdownList"
        [(ngModel)]="CoreselectedItems"       
        (onSelect)="CoreonItemSelect($event)" 
        (onDeSelect)="CoreOnItemDeSelect($event)"
        (onSelectAll)="CoreonSelectAll($event)"
        (onDeSelectAll)="CoreonDeSelectAll($event)">
        </ng-multiselect-dropdown>
       </div>     

  </div>

</mat-card>

<mat-card class="documents" *ngIf="ContactName!=''">
  <div class="topBar">
    <span>{{ContactName}}</span>
    <div class="assignSave">      
      <button *ngIf="SaveContactButton" mat-stroked-button color="primary"
      (click)="SaveContactRole()">Save</button>
    </div>
  </div>
  <div class="roleList">     
      <div class="multiDrop">
        <ng-multiselect-dropdown
        [placeholder]="'Search or Select'"
        [settings]="ContactdropdownSettings"
        [data]="ContactdropdownList"
        [(ngModel)]="ContactselectedItems"
        (onSelect)="ContactonItemSelect($event)" 
        (onDeSelect)="ContactOnItemDeSelect($event)"
        (onSelectAll)="ContactonSelectAll($event)"
        (onDeSelectAll)="ContactonDeSelectAll($event)">
        </ng-multiselect-dropdown>
       </div>
  </div>

</mat-card>

<mat-card class="documents" *ngIf="CompanyName!=''">
  <div class="topBar">
    <span>{{CompanyName}}</span>
    <div class="assignSave">    
      <button *ngIf="SaveCompanyButton" mat-stroked-button color="primary"
      (click)="SaveCompanyRole()">Save</button>
    </div>
  </div>
  <div class="roleList">     
      <div class="multiDrop">
        <ng-multiselect-dropdown
        [placeholder]="'Search or Select'"
        [settings]="CompanydropdownSettings"
        [data]="CompanydropdownList"
        [(ngModel)]="CompanyselectedItems"
        (onSelect)="CompanyonItemSelect($event)" 
        (onDeSelect)="CompanyOnItemDeSelect($event)"
        (onSelectAll)="CompanyonSelectAll($event)"
        (onDeSelectAll)="CompanyonDeSelectAll($event)">
        </ng-multiselect-dropdown>
       </div>
  </div>

</mat-card>


<app-loader></app-loader>